import { CanActivateFn } from '@angular/router';

/**
 * Guard function to restrict access based on the current domain.
 *
 * Checks if the current window's hostname is included in the list of approved domains.
 * If not approved, redirects the user to a blank page and denies activation.
 *
 * Setting window.location.href = 'about:blank'; will work in all major browsers (Chrome, Firefox, Edge, Safari, etc.) to navigate the current window to a blank page.
 *
 * @returns {boolean} True if the domain is approved, false otherwise.
 */
export const domainGuard: CanActivateFn = () => {
  const approvedDomains = [
    'localhost',
    'dev-password.woolworths.com.au',
    'uat-password.woolworths.com.au',
    'password.woolworths.com.au'
  ];
  const currentDomain = window.location.hostname;
  const isDomainApproved = approvedDomains.includes(currentDomain);
  if (!isDomainApproved) {
    window.location.href = 'about:blank';
    return false;
  }
  return isDomainApproved;
};
